const frenchDateFormatter = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const frenchTimeFormatter = new Intl.DateTimeFormat('fr-FR', {
  hour: '2-digit',
  minute: '2-digit',
});

const parseWikiDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatWikiDate = (value, fallback = '-') => {
  const date = parseWikiDate(value);
  return date ? frenchDateFormatter.format(date) : fallback;
};

export const formatWikiTime = (value, fallback = '') => {
  const date = parseWikiDate(value);
  return date ? frenchTimeFormatter.format(date) : fallback;
};
